import {
  hierarchyContainer,
  ComponentBox,
  ComponentBoxHeaderFooter,
  intlShape,
  utils,
} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './HierarchyBox.less';
import {HierarchyType} from 'src/js/model/hierarchy';

const I18N = defineMessages({
  TITLE: {
    id: 'hierarchy.title',
    defaultMessage: 'BROWSE HIERARCHY',
    description: 'title text for hierarchy box',
  },
  HELP: {
    id: 'hierarchy.help',
    defaultMessage: 'This box is showing the hierarchies that can be browsed.',
    description: 'help text for hierarchy box',
  },
});

class HierarchyBox extends React.PureComponent {
  render() {
    const {
      config,
      hierarchyComponentStateId,
      hierarchyType,
      intl,
      onNodeClick,
    } = this.props;
    return (
      <div className={styles.dlHierarchyBox}>
        <ComponentBoxHeaderFooter
          titleText={utils.TranslateUtils.translate(I18N.TITLE, intl)}
          helpText={utils.TranslateUtils.translate(I18N.HELP, intl)}
        />
        <ComponentBox>
          {hierarchyType ? (
            <hierarchyContainer.HierarchyContainer
              hierarchyStateId={hierarchyComponentStateId}
              rootLabel={hierarchyType.getName()}
              hierarchyTypeId={hierarchyType.getId()}
              onNodeClick={onNodeClick}
              childrenByParentUrl={config.service.url.hierarchyChildrenByParent}
              childrenByTypeUrl={config.service.url.hierarchyChildrenByType}
            />
          ) : null}
        </ComponentBox>
      </div>
    );
  }
}

HierarchyBox.displayName = 'HierarchyBox';

HierarchyBox.propTypes = {
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  hierarchyType: PropTypes.instanceOf(HierarchyType),
  hierarchyComponentStateId: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  onNodeClick: PropTypes.func,
};

HierarchyBox.defaultProps = {
  hierarchyType: undefined,
  onNodeClick: undefined,
};

export default injectIntl(HierarchyBox);
